exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".HelpCenterLink{z-index:9000;cursor:pointer;position:fixed;left:0;bottom:0;height:30px;color:#fff;background:#444;border-top-left-radius:5px;border-top-right-radius:5px;margin-left:10px}.HelpCenterLink .icon{display:inline-block;width:36px;border-top-left-radius:5px;padding-top:5px;vertical-align:text-top;text-align:center;background:#393939;color:#fff}.HelpCenterLink .content{font-size:12px;font-family:Verdana,Geneva,sans-serif;display:inline-block;overflow:hidden;vertical-align:text-top;font-weight:700;line-height:30px;padding-left:10px;padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/support/help_center_link.scss
// module id = 1412
// module chunks = 0